import NewCompanyForm from '../../components/NewCompanyForm/NewCompanyForm'

const NewCompany = () => {
  return <NewCompanyForm />
}

export default NewCompany
